import {Modal} from '@consta/uikit/Modal';
import {Text} from '@consta/uikit/Text';
import {SnackCmp} from "../../../component/snack.cmp";
import {DatePicker} from "@consta/uikit/DatePicker";
import {Combobox} from "@consta/uikit/Combobox";
import {TextField} from "@consta/uikit/TextField";
import {Button} from "@consta/uikit/Button";
import React, {useEffect, useState} from "react";
import {
    API_DOWNLOAD_ACT,
    API_PPK,
    API_URL_WELL
} from "../../../service/api.endpoint";
import api from "../api/api";
import {company} from "../../../component/header.cmp";
import moment from "moment/moment";
import cookieCmp from '../../../component/cookie.cmp';
import {IconSettings} from "@consta/uikit/IconSettings";
import {Slider} from "@consta/uikit/Slider";
import {DragNDropField} from "@consta/uikit/DragNDropField";
import {IconThumbUp} from "@consta/uikit/IconThumbUp";
import {v4 as uuidv4} from "uuid";

export type Item = {
    label: string;
    id: string;
    pk?: string;
};


interface ModalComponentProps {
    isOpen: boolean;
    onClose: any;
    nodeData: any;
    props: any;
    actPath?: any;
}

// Получение CSRF токена из cookies
const csrftoken = cookieCmp('csrftoken');

const ModalPPKView: React.FC<ModalComponentProps> = ({props, isOpen, onClose, nodeData, actPath}) => {
    const [isSaving, setIsSaving] = useState(false);
    const [valueWells, setValueWells] = useState<Item | null>();
    const [valueComment, setValueComment] = useState<string>('');
    const [itemsWells, setItemsWells] = useState<Item[]>([]);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [actualUntilDate, setActualUntilDate] = useState<Date | null>(null);
    const [isAlert, setIsAlert] = useState<string | null>(null)
    const [alertText, setAlertText] = useState<string>('')
    const [alertKey, setAlertKey] = useState(0)
    const [valueDepth, setValueDepth] = useState<number>(0);
    const [inputValue, setInputValue] = useState<string | undefined | null>();
    const [files, setFiles] = React.useState<File[]>([]);


    const handleSaveButton = async () => {
        setIsSaving(true); // Устанавливаем флаг сохранения в true
        try {
            await addPPK();
        } finally {
            setIsSaving(false);
        }
    };

    const handleCloseButton = () => {
        clearData()
        onClose(false);

    }

    function clearData() {
        setValueWells(null)
        setValueComment('')
        setStartDate(null)
        setEndDate(null)
        setActualUntilDate(null)
        setValueDepth(0)
        setFiles([])
    }

    const handleChangeComment = ({value}: { value: any }) => setValueComment(value);

    const showAlert = (type: string, message: string) => {
        setAlertText(message);
        setIsAlert(type);
        setAlertKey((key) => key + 1);
    }

    const addPPK = async () => {
        const formData = new FormData();
        const uuid = uuidv4();
        valueWells && valueWells.pk && formData.append('wells', valueWells.pk);
        company && formData.append('org_ppk', company);
        formData.append('ppk_date', nodeData ? nodeData.data?.date_from : startDate && moment(startDate.toLocaleString("ru-RU", {timeZone: "Asia/Yekaterinburg"}),
            'DD.MM.YYYY, HH:mm:ss').format('YYYY-MM-DD'));
        // company && formData.append('org', company);
        const commitDateValue = nodeData?.data?.ppk_commit_date
            || (nodeData?.data?.date_to ? nodeData.data.date_to : null)
            || (endDate ? moment(endDate.toLocaleString("ru-RU", {timeZone: "Asia/Yekaterinburg"}),
                'DD.MM.YYYY, HH:mm:ss').format('YYYY-MM-DD') : null)
        formData.append('ppk_commit_date', commitDateValue || 'null');
        if (actualUntilDate) {
            formData.append('actual_until', moment(actualUntilDate.toLocaleString("ru-RU", {timeZone: "Asia/Yekaterinburg"}),
                'DD.MM.YYYY, HH:mm:ss').format('YYYY-MM-DD'));
        } else if (nodeData?.data?.wells) {
            formData.append('actual_until', 'null');
        }
        formData.append('comment', valueComment);
        formData.append('depth', valueDepth.toString());
        formData.append('ppk_id', nodeData?.data?.wells && nodeData.data.pk);
        // @ts-ignore
        formData.append('username', localStorage.getItem('username'));

        if (nodeData?.data?.wells) {
            try {
                const response = await api.put(`${API_PPK}`, formData);
                // закрыть модальное окно
                showAlert('success', response.data?.detail || 'Акт сохранён. Пересчёт графика запущен в фоне.')
                clearData()
                onClose(formData);
                console.log('Запись успешно обновлена:', response.data);
            } catch (error: any) {
                showAlert('alert', 'Ошибка при обновлении записи!')
                onClose(false);
                console.error('Ошибка при обновлении записи:', error.response.data);
            }
        } else {
            formData.append('act', files[0], `${uuid}.pdf`);
            try {
                const response = await api.post(`${API_PPK}`, formData, {
                    headers: {
                        'X-CSRFToken': csrftoken
                    }
                });
                // закрыть модальное окно
                showAlert('success', response.data?.recalculation
                    ? 'Запись добавлена. Пересчёт графика запущен в фоне.'
                    : 'Запись успешно добавлена!')
                clearData()
                onClose(formData);
                console.log('Запись успешно добавлена:', response.data);
            } catch (error: any) {
                showAlert('alert', 'Ошибка при добавлении записи!')
                onClose(false);
                console.error('Ошибка при добавлении записи:', error.response.data);
            }
        }
    };


    const fetchWells = async (inputValue: any) => {
        try {
            const response = await api.get(API_URL_WELL, {
                params: {search: inputValue} // или другой параметр, который подходит вашему API
            });
            setItemsWells(response.data); // Установка состояния с полученными данными
        } catch (error) {
            console.error('Error fetching well list:', error);
            // Обработка ошибки здесь
        }
    };

    // const fetchAct = async (ppkID: string) => {
    //     try {
    //         const response = await axios.get(API_PPK_ACT, {
    //             params: {ppk_id: ppkID} // или другой параметр, который подходит вашему API
    //         });
    //         setActPath(response.data.act); // Установка состояния с полученными данными
    //     } catch (error) {
    //         console.error('Error fetching act:', error);
    //         // Обработка ошибки здесь
    //     }
    // }


    // обновление списка скважин по вводу в поле
    useEffect(() => {
        if (inputValue && inputValue.length > 0) {
            fetchWells(inputValue);
        } else {
            setItemsWells([]);
        }
    }, [inputValue]);

    const handleWellChange = (value: any) => {
        setInputValue(value)
        setValueWells(value);
        setStartDate(null)
        setEndDate(null)
    };

    useEffect(() => {
        if (!isOpen) {
            return
        }
        setValueComment(nodeData?.data?.comment || '')
        if (nodeData?.data?.actual_until) {
            setActualUntilDate(moment(nodeData.data.actual_until, 'YYYY-MM-DD').toDate())
        } else {
            setActualUntilDate(null)
        }
    }, [isOpen, nodeData, props?.collName]);


    useEffect(() => {
        if (nodeData?.data.wells) {
            if (nodeData?.data.ppk_commit_date) {
                setIsSaving(false)
            } else {
                !endDate ? setIsSaving(true) : setIsSaving(false)
            }
        } else {
            if (!startDate || !valueWells || !valueDepth || files.length === 0) {
                setIsSaving(true);
            } else {
                setIsSaving(false);
            }
        }
    }, [startDate, endDate, actualUntilDate, valueWells, valueComment, files, nodeData]);

    const handleDateChange = async (date: any, action: string) => {
        if (action === 'from') {
            setStartDate(date)
        } else if (action === 'to') {
            setEndDate(date)
        } else {
            setActualUntilDate(date)
        }
    }

    const handleDropFiles = (files: any) => {
        setFiles(files)
    }


    const DownloadButton = async () => {
        try {
            const response = await api.get(API_DOWNLOAD_ACT, {
                params: {ppk_id: nodeData.data.pk},
                responseType: 'blob', // important to handle binary data
            });

            // Create a URL for the downloaded file and click it programmatically to start the download
            const ppkDate = moment(nodeData.data.ppk_date).format('DD_MM_YYYY')
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `АКТ_ППК_от_${ppkDate}_${nodeData.data.wells.label}.pdf`); // or use ppk.act.name if you can pass it to the frontend
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading the file', error);
        }
    };

    useEffect(() => {
        console.log(actPath)
        console.log(files)
    }, [actPath, files]);

    return (
        <>
            <Modal
                className="ppk-modal"
                isOpen={isOpen}
                hasOverlay
                // onClickOutside={onClose}
                onEsc={onClose}
            >
                {isAlert === 'alert' && <SnackCmp key={alertKey} alertType={isAlert} alertText={alertText}/>}
                <div style={modalShellStyle}>
                    <div style={modalHeaderStyle}>
                        <Text size="xl" weight="bold">
                            {nodeData?.data?.wells ? 'Акт ППК' : 'Добавить ППК'}
                        </Text>
                        {nodeData?.data?.wells && (
                            <Text view="secondary" size="s">
                                {moment(nodeData.data.ppk_date).format('DD.MM.YYYY')}
                            </Text>
                        )}
                    </div>

                    <div style={modalBodyStyle}>
                        {!nodeData?.data.wells ? (
                            <div style={sectionStyle}>
                                <div style={formGridStyle}>
                                    <Combobox
                                        items={itemsWells}
                                        value={valueWells}
                                        label="Скважина"
                                        onChange={({value}) => handleWellChange(value)}
                                        placeholder="Выберите скважину"
                                        onInputChange={({value}) => setInputValue(value)}
                                    />
                                    <DatePicker
                                        label="Дата акта ППК"
                                        value={startDate}
                                        onChange={({value}) => handleDateChange(value, 'from')}
                                        disabled={!valueWells}
                                    />
                                </div>
                                <Slider
                                    className="inputElement"
                                    value={valueDepth}
                                    label={`Глубина ${valueDepth} м`}
                                    withTooltip
                                    min={0}
                                    max={1000}
                                    step={1}
                                    view="default"
                                    leftSide="input"
                                    rightSide={IconSettings}
                                    onChange={({value}) => setValueDepth(value)}
                                />
                            </div>
                        ) : (
                            <div style={summaryCardStyle}>
                                <div>
                                    <Text view="secondary" size="s">Скважина</Text>
                                    <Text weight="bold">
                                        {nodeData.data.wells.name} (кп.№{nodeData.data.wells.bush.name})
                                    </Text>
                                </div>
                                <div>
                                    <Text view="secondary" size="s">Глубина ППК</Text>
                                    <Text weight="bold">{nodeData.data.depth} м</Text>
                                </div>
                                <div>
                                    <Text view="secondary" size="s">Подтверждение</Text>
                                    <Text weight="bold" view={nodeData?.data?.ppk_commit_date ? 'primary' : 'alert'}>
                                        {nodeData?.data?.ppk_commit_date
                                            ? moment(nodeData.data.ppk_commit_date).format('DD.MM.YYYY')
                                            : 'Не утвержден'}
                                    </Text>
                                </div>
                            </div>
                        )}

                        <div style={contentGridStyle}>
                            <div style={noteCardStyle}>
                                <Text weight="bold">Примечание</Text>
                                <TextField
                                    onChange={handleChangeComment}
                                    value={valueComment}
                                    type="textarea"
                                    rows={5}
                                    placeholder="Примечание"
                                    disabled={nodeData?.data.wells}
                                />
                            </div>

                            <div style={actCardStyle}>
                                <Text weight="bold">Акт</Text>
                                <Text size="s" view="secondary">
                                    PDF-файл акта ППК
                                </Text>
                                {files.length === 0 && (!actPath || actPath === '') ? (
                                    <DragNDropField
                                        multiple={false}
                                        onDropFiles={(files) => handleDropFiles(files)}
                                        accept={['.pdf']}
                                    >
                                        {({openFileDialog}) => (
                                            <Button size="s" view="secondary" onClick={openFileDialog} label="Прикрепить"/>
                                        )}
                                    </DragNDropField>
                                ) : (
                                    <Button size="s" view="secondary" onClick={DownloadButton} label="Скачать акт"/>
                                )}
                            </div>
                        </div>

                        {nodeData?.data?.wells && localStorage.getItem('username') === 'admin' && (
                            <div style={sectionStyle}>
                                <Text weight="bold">Актуальность ППК</Text>
                                <Text size="s" view="secondary">
                                    Если ППК перестал действовать после ремонта, укажите последнюю дату его актуальности.
                                </Text>
                                <div style={actualityGridStyle}>
                                    <DatePicker
                                        label="Актуальна до"
                                        value={actualUntilDate}
                                        onChange={({value}) => handleDateChange(value, 'until')}
                                        minDate={moment(nodeData.data.ppk_date, 'YYYY-MM-DD').toDate()}
                                    />
                                    <Button
                                        size="m"
                                        view="secondary"
                                        label="Сбросить"
                                        width="default"
                                        onClick={() => setActualUntilDate(null)}
                                    />
                                </div>
                            </div>
                        )}

                        {nodeData?.data?.wells && localStorage.getItem('username') === 'admin' && !nodeData?.data.ppk_commit_date && (
                            <div style={sectionStyle}>
                                <Text weight="bold">Подтверждение акта</Text>
                                <div style={actualityGridStyle}>
                                    <DatePicker
                                        label="Дата утверждения"
                                        value={endDate}
                                        onChange={({value}) => handleDateChange(value, 'to')}
                                        minDate={moment(nodeData?.data && nodeData.data.ppk_date, 'YYYY-MM-DD').toDate()}
                                    />
                                    <Button
                                        size="m"
                                        view="primary"
                                        label="Утвердить акт"
                                        iconLeft={IconThumbUp}
                                        width="default"
                                        onClick={handleSaveButton}
                                        disabled={isSaving}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <div style={modalFooterStyle}>
                        <Button
                            size="m"
                            view="secondary"
                            label="Отменить"
                            width="default"
                            onClick={handleCloseButton}
                        />
                        {nodeData?.data?.wells ? (
                            localStorage.getItem('username') === 'admin' && (
                                <Button
                                    size="m"
                                    view="primary"
                                    label="Сохранить"
                                    width="default"
                                    onClick={handleSaveButton}
                                    disabled={isSaving}
                                />
                            )
                        ) : (
                            <Button
                                size="m"
                                view="primary"
                                label="Сохранить"
                                width="default"
                                onClick={handleSaveButton}
                                disabled={isSaving}
                            />
                        )}
                    </div>
                </div>
            </Modal>
            {
                isAlert === 'success' && <SnackCmp key={alertKey} alertType={isAlert} alertText={alertText}/>
            }
        </>
    )
};

const modalShellStyle: React.CSSProperties = {
    width: '760px',
    maxWidth: 'calc(100vw - 32px)',
    maxHeight: 'calc(100vh - 32px)',
    display: 'flex',
    flexDirection: 'column',
    background: '#ffffff',
    borderRadius: '8px',
    overflow: 'hidden',
}

const modalHeaderStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    padding: '18px 22px',
    borderBottom: '1px solid #d0d5dd',
}

const modalBodyStyle: React.CSSProperties = {
    display: 'grid',
    gap: '14px',
    padding: '18px 22px',
    overflowY: 'auto',
}

const sectionStyle: React.CSSProperties = {
    display: 'grid',
    gap: '10px',
    padding: '12px',
    border: '1px solid #d0d5dd',
    borderRadius: '6px',
    background: '#f8fafc',
}

const formGridStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'minmax(260px, 1fr) 180px',
    gap: '12px',
    alignItems: 'end',
}

const summaryCardStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'minmax(220px, 1fr) 130px 150px',
    gap: '12px',
    padding: '12px',
    border: '1px solid #b9d8ef',
    borderRadius: '6px',
    background: '#eef7ff',
}

const contentGridStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) 210px',
    gap: '12px',
    alignItems: 'stretch',
    minWidth: 0,
}

const noteCardStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateRows: 'max-content 1fr',
    gap: '8px',
    padding: '12px',
    border: '1px solid #d0d5dd',
    borderRadius: '6px',
    background: '#ffffff',
    minHeight: '160px',
    minWidth: 0,
}

const actCardStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateRows: 'max-content max-content max-content',
    alignContent: 'start',
    gap: '8px',
    padding: '12px',
    border: '1px solid #d0d5dd',
    borderRadius: '6px',
    background: '#ffffff',
    minHeight: '160px',
    minWidth: 0,
}

const actualityGridStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: '180px max-content',
    gap: '10px',
    alignItems: 'end',
}

const modalFooterStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    padding: '14px 22px',
    borderTop: '1px solid #d0d5dd',
    background: '#f8fafc',
}

export default ModalPPKView;
